export default "__VITE_ASSET__805f3f55__"